(function () {
    "use strict";

    angular
        .module("showcaseApp")
        .directive("modalFiltersContent", modalFiltersContent);

    /** @ngInject */
    function modalFiltersContent() {
        return {
            restrict: "E",
            scope: {
                filters: "=",
                options: "=",
                list: "=",
                isImmoContext: "=",
                onClose: "&",
                onExpose: "&",
                response: "="
            },
            controller: ModalFiltersContentController,
            controllerAs: "vm",
            bindToController: true,
            templateUrl: "app/components/modal/side-modal/body-contents/filters/modal-filters-content.html",
            link: function (scope, element, attrs, ctrl) {
                if (ctrl && typeof scope.vm.onExpose === 'function') {
                    scope.vm.onExpose({ methods: { applyFilters: ctrl.applyFilters, closeModal: ctrl.closeModal } });
                }
            }
        };


    }
})();
